import { createContext } from 'react';
import { NOOP } from '../../../../utils/const.js';

/**
 * Contesto per le modali.
 * La struttura di una modale precede Header, Body e Footer.
 * Questi componenti sono in relazione tra loro e il contesto permette il passaggio di parametri e la comunicazione.
 *
 * Ad esempio, è utilizzato per gestire il movimento della modale con useChangeModalPosition.
 */
const ModalContext = createContext({
    dragging: false,
    onMouseDown: NOOP,
    overflow: 'none',
    maxHeight: '',
});

export { ModalContext as default };
